import React from "react"
import {
  Box,
  Container,
  Link,
  Text,
  useColorModeValue,
  Flex,
  Heading,
  Stat
} from "@chakra-ui/react"
import { Accordion } from "@chakra-ui/accordion"
import AccordionMenu from "../components/accordion/AccordionMenu"
import { sellerLeadFrequentlyAskedQuestions } from "../data/SellerLeadFrequentlyAskedQuestions"
import ButtonPrimary from "../components/buttons/PrimaryButton"
import Meta from "../components/meta/Meta"
import styles from "../styles/seller-lead.module.css"
import Comprehensive from "../public/img/business-metrics-health.png"
import Advanced from "../public/img/seller-leads-advanced.png"
import Customized from "../public/img/seller-leads-customized.png"
import { CheckIcon } from "@chakra-ui/icons"
import Image from "next/image"
import NextLink from "next/link"

export default function SellerLeads() {

  function ButtonClick() {
  }
  const textColor = useColorModeValue("gray.500", "white")
  return (
    <>
      <Meta
        pageName={"Amazon Seller Leads: 5 Million+ Amazon Sellers Directory | TrackSellers"}
        description={"Want to sell via third party Amazon sellers? Use our Amazon Sellers Leads solution to filter over 5 million Amazon sellers & grow your business."}
        hrefLink={"https://www.tracksellers.com/seller-leads"}
      />
      <Box className={styles.LeadMainBox}>
        <Container maxW="container.xl">
          <Box>
            <Box className={styles.LeadSubBox}>
              <Heading as={"h1"} mb="25px" className={styles.LeadSubBoxHead}>
                The Ultimate Platform to get Amazon Seller Leads
              </Heading>
              <Text fontSize={{ base: "1.2rem", md: "1.2rem", lg: "1.5rem" }} maxW={{ base: "100%", md: "100%", lg: "70%" }} className={styles.SellerLeadSubHead}>
                Unlock the full potential of Amazon seller lead generation with our comprehensive database and advanced search features.
              </Text>
              {/* <Box mt="2rem">
                <Link >
                  <ButtonPrimary ButtonClick={ButtonClick} buttonName="Contact Us" />
                </Link>
              </Box> */}
            </Box>
          </Box>
          <Box pt="0rem">
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems="center"
                direction={{ base: "column", sm: "column", md: "column", lg: "row" }}>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={Comprehensive}
                    alt="Comprehensive"
                  />
                </Box>
                <Box flex="1"
                  pl={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pr={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Stat me="auto">
                    <Heading as={"h2"} color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }}
                      mb={{ base: "5px", md: "10px", lg: "10px" }}
                    >
                      Comprehensive Amazon Seller Leads Data and In-Depth Metrics
                    </Heading>
                    <Box mt="1.5rem">
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Access 5 million Amazon seller companies to gain a competitive edge
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Targeted Amazon seller leads
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Holistic view of each seller&apos;s business with detailed metrics
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Monitor market trends and adapt to the ever-changing landscape
                        </Text>
                      </Flex>
                    </Box>
                  </Stat>
                </Box>
              </Flex>
            </Box>
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems="center"
                direction={{ base: "column-reverse", md: "column-reverse", lg: "row" }}>
                <Box flex="1"
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Heading as={"h2"} color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }} mb="15px">
                    Advanced Seller Search and Customization
                  </Heading>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Filter through 5 million sellers to find the perfect leads
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Customize search based on attributes like rank, category, and location
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Tailor lead lists to target the most promising sellers
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Unmatched depth and breadth of information on Amazon sellers
                    </Text>
                  </Flex>
                </Box>
                <Box flex="1" className={styles.SellerIntelligenceReportImage} p="20px 0px">
                  <Image
                    src={Advanced}
                    alt="Advanced"
                  />
                </Box>
              </Flex>
            </Box>
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems="center"
                direction={{ base: "column", md: "column", lg: "row" }}>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={Customized}
                    alt="Customized"
                  />
                </Box>
                <Box flex="1"
                  pl={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pr={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}
                >
                  <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }} mb="15px">
                  Customized Amazon Seller Leads Lists and Support
                  </Heading>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w="100%" color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Tailor your lead lists based on specific criteria
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w="100%" color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Ensure you target only the most relevant sellers
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w="100%" color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Prompt assistance and guidance from our support team
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w="100%" color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Reach Amazon sellers at any scale, from 100 to 10,000 leads/month
                    </Text>
                  </Flex>
                </Box>
              </Flex>
            </Box>
          </Box>
        </Container>
        <Box mt="2rem" mb="2rem" textAlign="center" >
          <Text fontSize={{ base: "1rem", md: "1.2rem", lg: "1.2rem" }} color={textColor} className={styles.ReportText} mt="0.5rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
            Ready To Power Up Your Amazon Seller Lead Generation?
          </Text>
          <Text fontSize={{ base: "1rem", md: "1.2rem", lg: "1.2rem" }} color={textColor} className={styles.ReportText} mt="0.5rem" mb="1.5rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
            Sign up for a FREE trial today and gain access to our comprehensive database of Amazon seller leads. Unlock the full potential of your lead generation efforts and stay ahead of the competition.
          </Text>
          <NextLink href={"/get-started"} passHref>
            <Link >
              <ButtonPrimary ButtonClick={ButtonClick} buttonName="Get Started" />
            </Link>
          </NextLink>
        </Box>
        <Box pt="4rem" pb="4rem" pl="15px" pr="15px" background="#fff">
          <Box className={styles.LeadFaqBox}>
            <Heading className={styles.LeadFaqHead}>
              Frequently Asked Questions
            </Heading>
            <Accordion w="100%" maxWidth="800px" allowToggle defaultIndex={[0]} allowMultiple={false}>
              {
                sellerLeadFrequentlyAskedQuestions?.map((ques, index) => (
                  <AccordionMenu {...ques} key={index} />))
              }
            </Accordion>
          </Box>
        </Box>
      </Box>
    </>
  )
}